export default __webpack_public_path__ + "static/media/kitchen4-afterC-2048w.3081d744.avif";